import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { analytics } from '@/lib/analytics';

/**
 * RouteTracker — fires `page_view` analytics events on every navigation.
 *
 * Mounted INSIDE <BrowserRouter /> so it can call useLocation(). Renders
 * nothing. Extracts arche_id from /a/<id>/* URLs so the dashboard can
 * roll up arche-specific traffic.
 *
 * The page CATEGORY (e.g. 'arche_view', 'dev_console_tool') is computed
 * inside `analytics.pageView()` — see the normalizePagePath helper there.
 * The full path goes in the event's `pagePath` column.
 */
export function RouteTracker(): null {
  const location = useLocation();

  useEffect(() => {
    const archeMatch = location.pathname.match(/^\/a\/([^/]+)/);
    const archeId = archeMatch ? archeMatch[1] : undefined;
    analytics.pageView(location.pathname, archeId);
  }, [location.pathname]);

  return null;
}
